import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useAdminMode from '../hooks/useAdminMode';
import './AdminModeBar.css';

const ADMIN_BAR_HEIGHT = '34px';

export default function AdminModeBar() {
  const { isAdmin, exitAdminMode } = useAdminMode();

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--admin-bar-height',
      isAdmin ? ADMIN_BAR_HEIGHT : '0px'
    );
    return () => {
      document.documentElement.style.setProperty('--admin-bar-height', '0px');
    };
  }, [isAdmin]);

  if (!isAdmin) return null;
  return (
    <div className="admin-mode-bar">
      <span className="admin-mode-bar__text">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        관리자 편집 모드 활성화 중
      </span>
      <div className="admin-mode-bar__actions">
        <Link to="/admin/company" className="admin-mode-bar__link">관리자 콘솔</Link>
        <button className="admin-mode-bar__exit" onClick={exitAdminMode}>편집 모드 종료</button>
      </div>
    </div>
  );
}
